import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useRef, useState } from 'react';
import classnames from 'classnames';
import { useIntl } from 'react-intl';
import { StyledAvatar } from './headerAvatarStyles';
import { EmbersMenu } from '../../menu/menu';
import { EmbersMenuItem } from '../../menuItem/menuItem';
export var EmbersHeaderAvatar = function EmbersHeaderAvatar(props) {
  var intl = useIntl();
  var avatarUrl = props.avatarUrl,
    initials = props.initials,
    handleClickAccount = props.handleClickAccount,
    handleSignOut = props.handleSignOut,
    signedIn = props.signedIn,
    handleSignIn = props.handleSignIn,
    disableSignOut = props.disableSignOut,
    hideAccount = props.hideAccount;
  var avatarAnchorRef = useRef(null);
  var focusRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    avatarMenuOpen = _useState2[0],
    setAvatarMenuOpen = _useState2[1];
  var closeOnClick = function closeOnClick() {
    setAvatarMenuOpen(false);
    focusRef.current.focus();
  };
  var getAvatarMenuItems = function getAvatarMenuItems() {
    var menuItems = [];
    if (!hideAccount) {
      var accountText = intl.formatMessage({
        id: 'embers.header.avatar.account',
        defaultMessage: 'Account'
      });
      menuItems.push( /*#__PURE__*/React.createElement(EmbersMenuItem, {
        key: "mobileAccount",
        "aria-label": accountText // prevents icon appearing in screen reader
        ,
        "aria-selected": undefined,
        onClick: function onClick() {
          if (handleClickAccount) {
            handleClickAccount();
          }
          closeOnClick();
        },
        prefixIcon: /*#__PURE__*/React.createElement("span", {
          className: "icon-user"
        })
      }, accountText));
    }
    var signoutText = intl.formatMessage({
      id: 'embers.header.avatar.signOut',
      defaultMessage: 'Sign out'
    });
    menuItems.push( /*#__PURE__*/React.createElement(EmbersMenuItem, {
      key: "signout",
      "aria-label": signoutText // prevents icon appearing in screen reader
      ,
      "aria-selected": undefined,
      disabled: disableSignOut,
      onClick: function onClick() {
        if (handleSignOut) {
          handleSignOut();
        }
        closeOnClick();
      },
      prefixIcon: /*#__PURE__*/React.createElement("span", {
        className: "icon-sign-out"
      })
    }, signoutText));
    return menuItems;
  };
  var handleOpenMenuRequest = function handleOpenMenuRequest(buttonElem) {
    avatarAnchorRef.current = buttonElem;
    focusRef.current = document.activeElement;
    if (signedIn) {
      setAvatarMenuOpen(true);
    } else {
      if (handleSignIn) {
        handleSignIn();
      }
    }
  };
  var handleCloseMenuRequest = function handleCloseMenuRequest() {
    avatarAnchorRef.current = null;
    closeOnClick();
  };
  var notSignedInProps = signedIn ? {} : {
    component: 'a',
    'aria-haspopup': undefined,
    role: 'link'
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledAvatar, _extends({
    className: classnames('EmbersHeader-avatar-root', {
      'EmbersHeader-avatar-icon': !avatarUrl && signedIn,
      'EmbersHeader-avatar-notSignedIn': !signedIn
    }),
    label: signedIn ? intl.formatMessage({
      id: 'embers.header.eA.account',
      defaultMessage: 'Promethean Account'
    }) : intl.formatMessage({
      id: 'embers.header.eA.signIn',
      defaultMessage: 'Sign in to Promethean account'
    }),
    ariaProps: {
      'aria-controls': signedIn && avatarMenuOpen ? 'avatar-menu' : undefined
    },
    noPopup: !signedIn,
    tabIndex: 0,
    onOpenMenuRequest: handleOpenMenuRequest,
    onCloseMenuRequest: handleCloseMenuRequest,
    menuIsOpen: avatarMenuOpen
  }, notSignedInProps), signedIn ? avatarUrl ? /*#__PURE__*/React.createElement("img", {
    className: "EmbersHeader-avatar-img",
    src: avatarUrl,
    alt: "avatar",
    "aria-hidden": "true"
  }) : /*#__PURE__*/React.createElement("div", {
    className: "EmbersHeader-avatar-initials"
  }, initials) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "EmbersHeader-avatar-signInText"
  }, intl.formatMessage({
    id: 'embers.header.avatar.signIn',
    defaultMessage: 'Sign in'
  })), /*#__PURE__*/React.createElement("span", {
    className: "icon-user-alt"
  }))), /*#__PURE__*/React.createElement(EmbersMenu, {
    id: "avatar-menu",
    anchorEl: avatarAnchorRef.current,
    open: avatarMenuOpen,
    onClose: closeOnClick,
    placement: "bottom-end",
    verticalOffset: 4
  }, getAvatarMenuItems()));
};